var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tile_container tile",on:{"click":function($event){return _vm.$emit('click', _vm.part)}}},[_c('img',{staticClass:"icon",attrs:{"src":_vm.part.image}}),_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.part.name))]),_c('span',{staticClass:"quantity"},[_vm._v(_vm._s(`x${_vm.part.quantity}`))])])
}
var staticRenderFns = []

export { render, staticRenderFns }